import { Link } from "react-router";
import {
  Card,
  CardHeader,
  HeaderLeft,
  CardAccent,
  CardTitle,
  ViewAll,
  UpdateList,
  UpdateItem,
} from "./Dashboard.styles";
import {

  UpdateTitleWrapper,
  UpdateTitle,
  Tooltip,
} from "./Dashboard.styles";
import { updates } from "../../data/dashboardData";

const UpdatesCard = () => {

  return (
    <Card>
      <CardHeader>
        <HeaderLeft>
          <CardAccent />
          <CardTitle>Updates</CardTitle>
        </HeaderLeft>

        <ViewAll as={Link} to="/updates">
          View All Updates
        </ViewAll>
      </CardHeader>

      <UpdateList>
        {updates.map((item) => (
          <UpdateItem
            key={item.title}
            as={item.route ? Link : "div"}
            to={item.route || undefined}
            $clickable={Boolean(item.route)}
          >
           <UpdateTitleWrapper>
  <UpdateTitle>{item.title}</UpdateTitle>

  <Tooltip className="tooltip" aria-hidden="true">
    {item.title}
  </Tooltip>
</UpdateTitleWrapper>

<span
  className="text-sm text-slate-600"
  style={{ whiteSpace: "nowrap", flexShrink: 0 }}
>
  {item.date}
</span>
          </UpdateItem>
        ))}
      </UpdateList>
    </Card>
  );
};

export default UpdatesCard;
